<template>
  <div class="home">
    <Layout>
      <Tip v-for="(item, index) in tips" :key="index" :slot="'tip' + (index + 1)" :value="item" />
      <Area slot="area" class="slot" />
      <Year slot="year" class="slot" />
      <Map slot="map" class="slot" @change-map="changeMap" :mapType="mapType" :lines="globleLines" />
      <Proportion
        slot="proportion"
        class="slot height-35"
        :blockchain="blockchain"
        :oldBlockchain="oldBlockchain"
      />
      <Enterprise slot="enterprise" class="slot" :enterprise="enterprise" />
      <!-- <Statistics
        slot="statistics"
        class="slot"
        :statistics="statistics.map(i => ({ ...i, query: Math.floor(i.query / 45) }))"
      /> -->
       <Statistics
        slot="statistics"
        class="slot"
        :statistics="statistics"
      />
      <Record slot="record" class="slot" :record="record" :oldRecord="oldRecord" />
    </Layout>
  </div>
</template>

<script>
// @ is an alias to /src
import Layout from '@/components/Layout.vue'

import Tip from '@/components/slots/Tip'
import Enterprise from '@/components/slots/Enterprise'
import Statistics from '@/components/slots/Statistics'
import Record from '@/components/slots/Record'
// import MapTip from '@/components/slots/MapTip'

import Area from '@/components/slots/Area'
import 'echarts/lib/chart/bar'

import Year from '@/components/slots/Year'
import 'echarts/lib/chart/line'

import Proportion from '@/components/slots/Blockchain'
import 'echarts/lib/chart/pie'

import Map from '@/components/slots/MapList'

import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'

import axios from 'axios'
// const formatNum = num => {
//   if (typeof num !== 'number') {
//     return 'NaN'
//   }
//   let s = ''
//   let r = num
//   while (r) {
//     const result = r % 1000
//     if (s) {
//       s = result + ',' + s
//     } else {
//       s = result + ''
//     }
//     r = Math.floor(r / 1000)
//   }
//   return s
// }
const contrastArray = (a, b, id) => {
  const first = a[0] || {}
  for (let i = 0; i < b.length; i++) {
    if (first[id] === b[i][id]) {
      return i
    }
  }
  return b.length
}

export default {
  name: 'home',
  components: {
    Layout,
    Tip,
    Area,
    Year,
    Proportion,
    Enterprise,
    Statistics,
    Record,
    // MapTip
    Map
  },
  data () {
    return {
      setInterval: null,
      mapType: 'China',
      // eslint-disable-next-line
      Geo: new BMap.Geocoder(),
      globleLines: [],
      tips: [],
      enterprise: [],
      statistics: [
        // {
        //   name: "食品饮料",
        //   enterprise: 5176,
        //   commodity: 638706,
        //   query: 287611
        // },
        // {
        //   name: "医药卫生",
        //   enterprise: 2231,
        //   commodity: 263432,
        //   query: 135302
        // },
        // {
        //   name: "农林牧渔",
        //   enterprise: 3836,
        //   commodity: 395621,
        //   query: 153617
        // },
        // {
        //   name: "日用化妆",
        //   enterprise: 2867,
        //   commodity: 298830,
        //   query: 112431
        // },
        // {
        //   name: "机械机电",
        //   enterprise: 2534,
        //   commodity: 265607,
        //   query: 135427
        // },
        // {
        //   name: "电子电工",
        //   enterprise: 2890,
        //   commodity: 301003,
        //   query: 102519
        // },
        // {
        //   name: "农资产品",
        //   enterprise: 3769,
        //   commodity: 388904,
        //   query: 184162
        // },
        // {
        //   name: "医疗器械",
        //   enterprise: 1329,
        //   commodity: 386923,
        //   query: 201101
        // },
        // {
        //   name: "服装纺织",
        //   enterprise: 2553,
        //   commodity: 388956,
        //   query: 163128
        // },
        // {
        //   name: "家居用品",
        //   enterprise: 1622,
        //   commodity: 385938,
        //   query: 125122
        // },
        // {
        //   name: "石油化工",
        //   enterprise: 1832,
        //   commodity: 388902,
        //   query: 201008
        // },
        // {
        //   name: "建筑建材",
        //   enterprise: 1639,
        //   commodity: 382972,
        //   query: 192103
        // },
        // {
        //   name: "办公文教",
        //   enterprise: 1737,
        //   commodity: 388900,
        //   query: 110095
        // }
      ],
      // 实时访问数据
      record: [],
      oldRecord: [],
      // 区块链
      blockchain: [],
      oldBlockchain: []
    }
  },
  methods: {
    getBlockchain (blockchain) {
      const newBlockchain = blockchain.slice(
        0,
        contrastArray(this.blockchain, blockchain, 'BlockchainId')
      )
      this.oldBlockchain = this.blockchain.slice(
        this.blockchain.length -
          contrastArray(this.blockchain, blockchain, 'BlockchainId')
      )
      this.blockchain.unshift(...newBlockchain)
      // this.oldBlockchain = this.blockchain.slice(Math.floor(Math.random() * 12))
      newBlockchain.forEach((item, index) => {
        if (this.blockchain.length > 12) {
          this.blockchain.pop()
        }
      })
    },
    getTips (baseUrl) {
      axios.get(`${baseUrl}/BigData/GetBigScreenDataJson`).then(({ data }) => {
        // 行业处理
        // console.info(data.IndustryList)
        this.statistics = data.IndustryList

        this.statistics.forEach((item, index) => {
          item.name = data.IndustryList[index].industryName
          item.enterprise = data.IndustryList[index].baseCompany
          item.commodity = data.IndustryList[index].baseMakeCode
          item.query = data.IndustryList[index].baseQryCount
        })

        // tip处理
        const array = []
        // 当天入网网企业 累计入网企业 今天生码量 累计生码量 今天查询次数 累计查询次数 今天扫码量 累计扫码量
        array.push(
          data.TodayInCompany + '',
          data.AllInCompany + '',
          data.TodayMakeCode + '',
          `${Math.round(data.AllMakeCode / 10000)}万`,
          data.TodayQueryCnt + '',
          `${Math.round(data.AllQueryCnt / 10000)}万`,
          Math.floor(data.TodayQueryCnt * 0.8) + '',
          `${Math.round((data.AllQueryCnt * 0.75) / 10000)}万`
        )
        this.tips = array
        this.getBlockchain(data.BlockchainList)
      })
    },
    getRecord (baseUrl) {
      axios.get(`${baseUrl}/BigData/GetQueryRecordsJson`).then(({ data }) => {
        console.warn(contrastArray(this.record, data))
        const newRecord = data
          .slice(0, contrastArray(this.record, data, 'ID'))
          .map(item => ({
            ID: item.ID,
            time: new Date(`${item.QueryDate} ${item.QueryTime}`),
            user: item.QueryInfo,
            Address: item.QueryArea
          }))
        this.oldRecord = this.record.slice(
          this.record.length - contrastArray(this.record, data, 'ID')
        )
        this.record.unshift(...newRecord)
        // if (this.mapType === 'GLOBLE') {
        newRecord.forEach((item, index) => {
          if (item.user.indexOf('.') === -1) {
            window.jsonpGetPosition(index, {
              content: { address: item.Address }
            })
          } else {
            this.getPositionByIp(item.user, index)
          }
          if (this.record.length > 12) {
            this.record.pop()
          }
        })
        // }
      })
    },
    getEnterprise (baseUrl) {
      axios.get(`${baseUrl}/BigData/GetTop6Company`).then(({ data }) => {
        this.enterprise = data.map(i => i.CompanyName.replace('X', ''))
      })
    },
    getInfo () {
      const baseUrl =
        process.env.NODE_ENV === 'production'
          ? '//bigapi.wannengma.cn'
          : '/api'
      this.getRecord(baseUrl)
      this.getTips(baseUrl)
      this.getEnterprise(baseUrl)
    },
    changeMap (type) {
      if (this.mapType === 'MAP') {
        this.mapType = 'GLOBLE'
      } else if (this.mapType === 'GLOBLE') {
        this.mapType = 'CHINA'
      } else {
        this.mapType = 'MAP'
      }
    },
    getPositionByIp (ip, index) {
      const script = document.createElement('script')
      const src = `https://api.map.baidu.com/location/ip?ak=nSxiPohfziUaCuONe4ViUP2N&ip=${ip}&callback=jsonpGetPosition.bind(this, ${index})`
      script.src = src
      script.async = true
      script.defer = true
      document.body.appendChild(script)
      setTimeout(function () {
        document.body.removeChild(script)
      }, 2000)
    }
  },
  beforeCreate () {
    if (!this.$store.state.isLogin) {
      this.$router.replace({ name: 'login' })
    }
  },
  created () {
    window.jsonpGetPosition = (index, res) => {
      if (!res || !res.content || !res.content.address) {
        return
      }
      this.record[index].Address = res.content.address
      const basePosition = [118.8720703125, 31.7655374095]
      this.Geo.getPoint(res.content.address, point => {
        if (point) {
          const startPosition = [point.lng, point.lat]
          this.globleLines.push([startPosition, basePosition])
          if (this.globleLines.length > 12) {
            this.globleLines.shift()
          }
        }
      })
    }

    this.getInfo()
    this.setInterval = setInterval(this.getInfo, 4000)
  },
  destroyed () {
    clearInterval(this.setInterval)
  }
}
</script>

<style scoped>
.slot {
  width: 100%;
  height: 100%;
}
.height-35 {
  height: 35vh;
}
</style>
